import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../../common/StyledToolTip";
import { ToggleRenderer } from "./../../../../../components/dataGrid/cellRenderer";

const styles = theme => ({
  toggleAnimationButton: {
    float: "right",
    display: 'flex',
    alignItems: 'center',
  },
  toggleText: {
    display: "inline-block",
    fontSize: "12px",
    color: theme.iconColor
  },
});

const ToggleAnchorPoints = (props) => {
  const {
    classes,
    isOnClickDisabled = false,
    isEnableAnchorPointsInProgress,
  } = props;
  return (
    <Tooltip title={props.title}>
      <span className={`${classes.toggleAnimationButton} `}>
        <span className={classes.toggleText}>
          {props.isEnabled ? "Disable all" : "Enable all"}
        </span>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={() => props.onClick && props.onClick()}
          context={{
            disabled: isOnClickDisabled || isEnableAnchorPointsInProgress,
          }}
        />
      </span>
    </Tooltip>
  );
};

export default withStyles(styles)(ToggleAnchorPoints);
